import { ShieldCheck } from "lucide-react";
import type { NavItem } from "./navigation";

export const VERIFICATION_NAV_ENTRY: NavItem = {
  to: "/commerce/verifications",
  label: "Verification",
  icon: ShieldCheck,
  moduleAny: ["marketplace", "instalments"],
  permAny: ["marketplace.verify_kyc", "flexxi.verify_kyc"],
  keywords: ["kyc", "verification", "seller", "flexxi", "identity"],
};
